import script from "./GreenifiedProductTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./GreenifiedProductTable.vue?vue&type=script&lang=ts&setup=true"

import "./GreenifiedProductTable.vue?vue&type=style&index=0&id=17639f1f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17639f1f"]])

export default __exports__